import styled from "styled-components";

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: 13px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const LabelText = styled.span`
  display: block;
  font-size: 12.5px;
  font-weight: 700;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-bottom: 6px;
`;

export const Optional = styled.span`
  font-weight: 600;
  color: #a8b5b0;
`;

export const StyledInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1.5px solid ${(p) => p.theme.tokens.colors.inputBorder};
  border-radius: 13px;
  padding: 12px 14px;
  font-size: 14.5px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 600;
  color: ${(p) => p.theme.tokens.colors.ink};
  outline: none;
  background: ${(p) => p.theme.tokens.colors.inputBg};

  &:focus {
    border-color: ${(p) => p.theme.tokens.colors.green};
  }
`;
